import React from 'react'
import emailjs from 'emailjs-com';

export default function Contact() {
    const sendEmail=(e)=> {
        e.preventDefault();
    
        emailjs.sendForm('Test', 'template_ro8r2u9', e.target, 'user_Us6SWB6JqXIJh2J13TRAO')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
        e.target.reset()
    }
    return (
        <div>
            <section class="contact">
                <div class="contact-wrapper">
                <div class="contact-left"></div>
                <div class="contact-right">
                    <h1 class="contact-heading">Contact</h1>
                    <form onSubmit={sendEmail}>
                        <div class="input-group">
                            <input type="text" class="field" name="from_name"/>
                            <label class="input-label">Full Name</label>
                        </div>
                        <div class="input-group">
                            <input type="email" class="field" name='email_address' />
                            <label class="input-label">Email</label>
                        </div>
                        <div class="input-group">
                            <input type="number" class="field" name='phone_number'/>
                            <label class="input-label">Phone Number</label>
                        </div>
                        <div class="input-group">
                            <textarea class="field" name='message'></textarea>
                            <label class="message">Message</label>
                        </div>
                        <input type="submit" class="submit-btn" value="Submit" />
                    </form>
                </div>
                </div>
                
            </section>
        </div>
    )
}
